(function () {

	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);
		footerDetails.forEach((targetDetail) => {
			targetDetail.addEventListener('click', () => {
				footerDetails.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute('open');
					}
				});
			});
		});

      function animateTypingLabelWithBackspace(elementSelector, staticText, animatedPhrases, typeSpeed = 75, deleteSpeed = 50, pauseAfterType = 1500, pauseAfterDelete = 500) {
  const label = document.querySelector(elementSelector);
  if (!label) {
    console.error("Label element not found for selector:", elementSelector);
    return;
  }

  let currentPhraseIndex = 0;
  let charIndex = 0;
  let isDeleting = false;

  function typeWriter() {
    const currentPhrase = animatedPhrases[currentPhraseIndex];
    let displayText;

    if (isDeleting) {
      // Deleting characters
      charIndex--;
      displayText = staticText + " " + currentPhrase.substring(0, charIndex);
    } else {
      // Typing characters
      charIndex++;
      displayText = staticText + " " + currentPhrase.substring(0, charIndex);
    }

    label.textContent = displayText;

    let typeDelay = typeSpeed;

    if (isDeleting) {
      typeDelay = deleteSpeed;
    }

    if (!isDeleting && charIndex === currentPhrase.length) {
      // Fully typed, now pause before starting to delete
      typeDelay = pauseAfterType;
      isDeleting = true;
    } else if (isDeleting && charIndex === 0) {
      // Fully deleted, now switch to the next phrase
      isDeleting = false;
      currentPhraseIndex = (currentPhraseIndex + 1) % animatedPhrases.length;
      typeDelay = pauseAfterDelete; // Pause briefly before typing the next one
    }

    setTimeout(typeWriter, typeDelay);
  }

  // Initial call to start the typing animation
  typeWriter();
}

// --- Usage ---
// Call this function with your specific label selector and desired phrases
animateTypingLabelWithBackspace(
  'label.field__label[for="Search-In-Modal-1"]',
  "Search for",             // The static part of the label
  ["blog posts...", "collections...", "products..."], // The phrases to type animate
  100,                       // typeSpeed: Speed of typing each character (milliseconds)
  80,                       // deleteSpeed: Speed of deleting each character (milliseconds)
  2000,                     // pauseAfterType: Pause duration after typing a phrase (milliseconds)
  700                       // pauseAfterDelete: Pause duration after deleting a phrase, before typing next (milliseconds)
);
      
	}

	document.addEventListener('shopify:section:load', footer);
	footer();

  

})();